const CheckCircle = ({ color, type }) => {
  const regular = (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33334 20C3.33334 10.7953 10.7953 3.33337 20 3.33337C22.6119 3.33337 25.0879 3.93537 27.2926 5.00973C28.1201 5.41296 28.464 6.41062 28.0608 7.23808C27.6575 8.06553 26.6599 8.40944 25.8324 8.00622C24.0726 7.14867 22.095 6.66671 20 6.66671C12.6362 6.66671 6.66668 12.6362 6.66668 20C6.66668 27.3638 12.6362 33.3334 20 33.3334C27.3638 33.3334 33.3333 27.3638 33.3333 20C33.3333 19.0796 34.0795 18.3334 35 18.3334C35.9205 18.3334 36.6667 19.0796 36.6667 20C36.6667 29.2048 29.2048 36.6667 20 36.6667C10.7953 36.6667 3.33334 29.2048 3.33334 20ZM33.366 9.44653C34.0169 10.0974 34.0169 11.1527 33.366 11.8036L20.241 24.9286C19.5901 25.5794 18.5349 25.5794 17.884 24.9286L14.134 21.1786C13.4831 20.5277 13.4831 19.4724 14.134 18.8215C14.7849 18.1707 15.8401 18.1707 16.491 18.8215L19.0625 21.393L31.009 9.44653C31.6599 8.79566 32.7151 8.79566 33.366 9.44653Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default CheckCircle;
